import React from 'react';
import './PersonalPrivacyLockIcon.css';

/**
 * Red padlock in an embedded chip — personal-private workspace indicator.
 */
export default function PersonalPrivacyLockIcon({
  size = 'md',
  title = 'Personal-private workspace',
  className = '',
}) {
  const combined = ['v-privacy-lock', `v-privacy-lock--${size}`, className].filter(Boolean).join(' ');
  return (
    <span className={combined} title={title} role="img" aria-label={title}>
      <svg viewBox="0 0 24 24" aria-hidden className="v-privacy-lock__svg">
        <path
          fill="currentColor"
          d="M18 10h-1V8c0-2.76-2.24-5-5-5S7 5.24 7 8v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V12c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V8c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
        />
      </svg>
    </span>
  );
}
